import {useEffect} from "react";
import {usePage} from "@inertiajs/react";
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx";

export default function useFatalError() {
    const {props} = usePage();
    const {errors = {}} = props;
    const {basketStore = {}} = useStoreMobx();

    useEffect(() => {
        if (errors?.fatalErrorMessage) {
            basketStore.errorOrderMessage = errors.fatalErrorMessage;
            basketStore.openDialogBasket();
        }
    }, [errors]);
}
